import styled from "styled-components";

const TextareaStyled = styled.div`
    padding: 1.25rem;
    border: ${props => props.theme.lightGrayBorder};
    position: relative;

    span {
        display: block;
        margin-bottom: 0;
        font-size: 1.4rem;
    }

    & > p {
        margin-bottom: 0;
    }

    button {
        color: ${props => props.theme.lightGreen};
        font-weight: bold;
        position: absolute;
        right: 2rem;
        font-size: 1.4rem;
        top: 2rem;

        svg {
            margin-right: 1rem;
        }
    }
`;

export default TextareaStyled;
